// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e1bbd58","389":"1237b90e","732":"8eada694","782":"1012e335","977":"e8b3a7c6"}[chunkId] + ".chunk.js";
};